import './AppDate.scss';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { DateValidationError } from '@mui/x-date-pickers/internals';
import { fr, enCA } from 'date-fns/locale';
import { LANGUAGE } from '../../../constants/common';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { useTranslation } from 'react-i18next';
import AppText from '../AppText/AppText';
import CalendarTodayIcon from '@mui/icons-material/CalendarToday';

interface Props {
  label: string;
  value: string | any;
  width: number;
  onChange: (value: any, keyboardInputValue?: string | undefined) => void;
  error?: boolean;
  helperText?: string;
  minDate?: Date;
  onError?: (reason: DateValidationError, value: any) => void;
}

const AppDate = ({label, value, width, onChange, error, helperText, minDate, onError}: Props) => {

  const { i18n } = useTranslation();
  const datePickerInputAdornmentProps = {
    sx:{
      '& .MuiIconButton-root': {
        '&:hover': {
          backgroundColor: 'transparent'
        }
      },

      '& .MuiSvgIcon-root': {
        color: 'black',
        height: '2.2rem',
        marginRight: '1.3rem',
        marginBottom: '1.4rem',
        paddingLeft: '0.35rem',
        paddingRight: '0.35rem',
        transform: 'scale(1.8)'
      },

      '& .MuiTouchRipple-root': {
        bottom: '1rem',
        position: 'absolute',
        right: '1.2rem',
        zIndex: 0
      }
    }
  };

  return (
    <LocalizationProvider
      adapterLocale={i18n.language === LANGUAGE.fr ? fr : enCA}
      dateAdapter={AdapterDateFns}
    >
      <DatePicker
        components={{OpenPickerIcon: CalendarTodayIcon}}
        disableMaskedInput
        inputFormat="dd/MM/yyyy"
        InputAdornmentProps={datePickerInputAdornmentProps}
        InputProps={{disableUnderline: true}}
        minDate={minDate && minDate}
        onChange={onChange}
        onError={onError && onError}
        value={value ? value : null}
        renderInput={params => (
          <AppText
            label={label}
            width={width}
            helperText={helperText}
            parentField={params}
            error={error}
          />
        )}
      />
    </LocalizationProvider>
  );
};

export default AppDate;
